module.exports = __webpack_public_path__ + "img/building6.0d7e03ba.jpg";